import type {
  IDraftBoundaryGeometryRequest,
  IGapFillDraftOverrides,
} from "@/providers/store/api/custom-layers/custom-layers.interface";

export function mapFeaturesToGapFillDraftOverrides(
  features: GeoJSON.Feature[],
  getBoundaryId: (feature: GeoJSON.Feature) => string | null | undefined,
): IGapFillDraftOverrides {
  const deletedBoundaryIds: string[] = [];
  const draftBoundaries: IDraftBoundaryGeometryRequest[] = [];

  for (const feature of features) {
    const id = getBoundaryId(feature);
    if (!id) continue;

    if (feature.properties?.deleted) {
      deletedBoundaryIds.push(id);
      continue;
    }

    if (
      feature.geometry?.type !== "Polygon" &&
      feature.geometry?.type !== "MultiPolygon"
    ) {
      continue;
    }

    draftBoundaries.push({
      id,
      geometry: feature.geometry,
    });
  }

  return { deletedBoundaryIds, draftBoundaries };
}
